// 1. 存储带过期时间的数据
export const setWithExpiry = (key, value, expiryInMinutes) => {
  const now = new Date();
  // 创建包含值和过期时间的对象
  const item = {
    value: value,
    expiry: now.getTime() + expiryInMinutes * 60 * 1000 // 过期时间戳（毫秒）
  };
  localStorage.setItem(key, JSON.stringify(item));
};

// 2. 读取并检查过期数据
export const getWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  // 如果不存在，返回null
  if (!itemStr) {
    return null;
  }
  
  const item = JSON.parse(itemStr);
  const now = new Date();
  
  // 检查是否过期
  if (now.getTime() > item.expiry) {
    // 过期则删除数据
    localStorage.removeItem(key);
    return null;
  }
  
  return item.value;
};